module.exports = __webpack_public_path__ + "img/Pages-icon.2db34767.svg";